
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../../lib/supabase';

interface SiteSettings {
  site_name?: string;
  site_description?: string;
  phone?: string;
  email?: string;
  address?: string;
  working_hours?: string;
  facebook_url?: string;
  instagram_url?: string;
  twitter_url?: string;
  youtube_url?: string;
}

export default function Footer() {
  const [settings, setSettings] = useState<SiteSettings | null>(null);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const { data, error } = await supabase
        .from('site_settings')
        .select('*')
        .eq('setting_key', 'site_settings')
        .maybeSingle();

      if (error && error.code !== 'PGRST116') {
        console.error('Error loading settings:', error);
        return;
      }
      
      if (data) {
        setSettings(data);
      }
    } catch (error) {
      console.error('Error loading settings:', error);
    }
  };

  return (
    <footer className="bg-[#1F1F1F] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Şirket Bilgisi */}
          <div>
            <h3 className="text-[#FCD34D] text-xl font-bold mb-4">
              {settings?.site_name || 'MRT Soft'}
            </h3>
            <p className="text-sm leading-relaxed">
              Aracınız için en iyi bakım ve detaylı temizlik hizmetleri. 2009'dan beri güvenilir hizmet.
            </p>
          </div>

          {/* Hızlı Bağlantılar */}
          <div>
            <h4 className="text-white font-semibold mb-4">Hızlı Bağlantılar</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-[#FCD34D] transition-colors cursor-pointer">
                  Ana Sayfa
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm hover:text-[#FCD34D] transition-colors cursor-pointer">
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm hover:text-[#FCD34D] transition-colors cursor-pointer">
                  Hizmetler
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-[#FCD34D] transition-colors cursor-pointer">
                  İletişim
                </Link>
              </li>
              <li>
                <Link to="/appointment" className="text-sm hover:text-[#FCD34D] transition-colors cursor-pointer">
                  Randevu Al
                </Link>
              </li>
            </ul>
          </div>

          {/* Çalışma Saatleri */}
          <div>
            <h4 className="text-white font-semibold mb-4">Çalışma Saatleri</h4>
            <div className="text-sm space-y-1 whitespace-pre-line">
              {settings?.working_hours || 'Pazartesi - Cuma: 08:00 - 18:00\nCumartesi: 10:00 - 17:00\nPazar: Kapalı'}
            </div>
          </div>

          {/* İletişim */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-[#FCD34D]">İletişim</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-line text-[#FCD34D] mt-1"></i>
                <p className="text-gray-400 text-sm">
                  {settings?.address || 'Gaziantep, Türkiye'}
                </p>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-phone-line text-[#FCD34D]"></i>
                <a href="tel:+905457455075" className="text-gray-400 text-sm hover:text-[#FCD34D] transition-colors cursor-pointer">
                  +90 545 745 50 75
                </a>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-mail-line text-[#FCD34D]"></i>
                <a href={`mailto:${settings?.email || 'mrrbzkrt1987@gmail.com'}`} className="text-gray-400 text-sm hover:text-[#FCD34D] transition-colors cursor-pointer">
                  {settings?.email || 'mrrbzkrt1987@gmail.com'}
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Alt Kısım */}
        <div className="border-t border-gray-800 pt-8">
          <p className="text-sm text-center">
            © 2025 {settings?.site_name || 'MRT Soft'}. Tüm hakları saklıdır.
          </p>
        </div>
      </div>
    </footer>
  );
}
